import { render } from "./MobileMenu.vue?vue&type=template&id=3c7884ba"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"

import "./MobileMenu.vue?vue&type=style&index=0&id=3c7884ba&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__